import styled from '@emotion/styled';

export const StyledForm = styled.div`
  grid-column: 2 / 11;
  display: flex;
  align-items: center;
  text-align: center;
  flex-direction: column;
`;
